export default {
  // name: 'searchBlockedPhrase',
  // name: 'searchImmutablePhrase',
  // name: 'searchSettings',
  // name: 'searchPhrasesReportWithNoResults',
  // name: 'searchWeightsSettings',
  // name: 'searchSortSettings',
  // name: 'addSortGroupInstance' :searchId,
  // name: 'searchFacetedSettings',
  // name: 'searchSuggestionSettings',
  // name: 'searchSharedFieldsSettings',
  // name: 'searchApiAccess',
  // name: 'searchSubscription',

  catalogInstances: { translate: 'breadcrumb.catalog.list', to: '/catalog/instances' },
  catalogMapping: {
    translate: 'breadcrumb.catalog.mappingInstanceId',
    to: '/catalog/mapping/{{catalogId}}',
    linkValueToForward: ['catalogId'],
  },
  catalogHistory: {
    translate: 'breadcrumb.catalog.historyInstanceId',
    to: '/catalog/history/{{catalogId}}',
    linkValueToForward: ['catalogId'],
  },
  catalogTime: {
    translate: 'breadcrumb.catalog.setImportTimeInstanceId',
    to: '/catalog/time/{{catalogId}}',
    linkValueToForward: ['catalogId'],
  },
  catalogInstance: {
    translate: 'breadcrumb.catalog.instanceId',
    to: '/catalog/instance/{{catalogId}}',
    linkValueToForward: ['catalogId'],
  },
  catalogInstanceProductsList: {
    translate: 'breadcrumb.catalog.instanceIdProductList',
    to: '/catalog/{{catalogId}}/productsList',
    linkValueToForward: ['catalogId'],
  },
  catalogInstanceCategories: {
    translate: 'breadcrumb.catalog.categoryMappingsWithId',
    to: '/catalog/instance/{{catalogId}}/categories',
    linkValueToForward: ['catalogId'],
  },
  catalogInstanceProductDetails: {
    translate: 'breadcrumb.product.id',
    to: '/catalog/instance/{{catalogId}}/product/{{productId}}',
    linkValueToForward: ['catalogId', 'productId'],
  },
  catalogInstanceImageDetails: {
    translate: 'breadcrumb.image.id',
  },
  catalogInstanceAdd: {
    translate: 'breadcrumb.catalog.createNew',
    to: '/catalog/instances/add',
  },

  instagramMain: { translate: 'breadcrumb.instagram.main', to: '/catalog/instagram' },

  searchInstances: {
    translate: 'breadcrumb.search.list',
    to: '/search/instances',
  },
  searchInstance: {
    translate: 'breadcrumb.search.instanceId',
    to: '/search/instance/{{searchId}}',
    linkValueToForward: ['searchId'],
  },
  searchInstanceAdd: {
    translate: 'breadcrumb.search.createNew',
    to: '/search/instances/add',
  },
  searchTry: {},

  // name: 'searchV3AllReports',
  //
  // name: 'searchV3AllPhrasesReport',
  // name: 'searchV3EmptySearchPhrasesReport',
  // name: 'appV3Settings',
  // name: 'appV3Labels',
  // name: 'stylistReports',
  // name: 'stylizationsList',
  // name: 'stylizationDetails',

}
